import { Action } from "redux";
import { UserProfile } from "../state";

export type AuthSetProfileRequest = "AUTH_SET_PROFILE";
export const AUTH_SET_PROFILE_REQUEST: AuthSetProfileRequest = "AUTH_SET_PROFILE";

export interface AuthSetProfileAction extends Action {
    payload: {
        profile: UserProfile
    };
    type: AuthSetProfileRequest;
}

export function setProfile(profile: UserProfile): AuthSetProfileAction {
    return {
        payload: {
            profile,
        },
        type: AUTH_SET_PROFILE_REQUEST
    };
}

